module.exports = __webpack_public_path__ + "static/three-best-rated-66abbcff670f7166119338dba17c2764.svg";